import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment-timezone'
import classnames from 'classnames'

export default class ReleaseTag extends React.Component {
  static propTypes = {
    tag_name: PropTypes.string,
    published_at: PropTypes.any,
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    isLatest: PropTypes.bool,
    isUnread: PropTypes.bool,
  }

  constructor() {
    super()

    this.state = {
      hover: false,
    }
  }

  onMouseEnter = () => {
    this.setState({ hover: true })
  }

  onMouseLeave = () => {
    this.setState({ hover: false })
  }

  render() {
    const { tag_name, published_at, onClick, isLatest, isUnread, isActive } =
      this.props
    const { hover } = this.state
    const className = classnames({
      active: isActive,
      latest: isLatest,
      unread: isUnread,
    })

    return (
      <li
        className={className}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={onClick}>
        <a href={`#${tag_name}`}>
          {tag_name}{' '}
          {hover && (
            <span>
              {moment
                .utc(published_at)
                .tz('America/Denver')
                .format('D MMM, YYYY')}
            </span>
          )}
        </a>
      </li>
    )
  }
}
